<template>
<div class="chapter">
<div class="inner_page">
<h2 class="fm-title1">CONTENTS</h2>
<p class="toc"><a href="#/xhtml/fm04">Introduction</a></p>
<p class="tocct"><span href="#/xhtml/chap01" title="Link target outside of Sample"><span class="tno">Chapter One:</span> Discovering Your Communication Home</span></p>
<p class="tocc"><span href="#/xhtml/chap02" title="Link target outside of Sample"><span class="tno">Chapter Two:</span> New School Technology (Life as We Know It)</span></p>
<p class="tocc"><span href="#/xhtml/chap03" title="Link target outside of Sample"><span class="tno">Chapter Three:</span> Relationships</span></p>
<p class="tocc"><span href="#/xhtml/chap04" title="Link target outside of Sample"><span class="tno">Chapter Four:</span> Ol’ School Simplicity (Pre-Digital Technology)</span></p>
<p class="tocc"><span href="#/xhtml/chap05" title="Link target outside of Sample"><span class="tno">Chapter Five:</span> Balancing Act</span></p>
<p class="tocc"><span href="#/xhtml/chap06" title="Link target outside of Sample"><span class="tno">Chapter Six:</span> Rollin’ with the Times</span></p>
<p class="tocc"><span href="#/xhtml/chap07" title="Link target outside of Sample"><span class="tno">Chapter Seven:</span> Disconnecting to Reconnect <i>(Practices Part 1)</i></span></p>
<p class="tocc"><span href="#/xhtml/chap08" title="Link target outside of Sample"><span class="tno">Chapter Eight:</span> Stepping into Your Power <i>(Practices Part 2)</i></span></p>
<p class="tocc"><span href="#/xhtml/chap09" title="Link target outside of Sample"><span class="tno">Chapter Nine:</span> Seizing an Opportunity</span></p>
<p class="tocc"><span href="#/xhtml/chap10" title="Link target outside of Sample"><span class="tno">Chapter Ten:</span> Claiming Who You Want to Be</span></p>
<p class="toct"><span href="#/xhtml/bm01" title="Link target outside of Sample">Answering the Final Question</span></p>
<p class="toc"><span href="#/xhtml/bm02" title="Link target outside of Sample">References</span></p>
<p class="toc"><span href="#/xhtml/bm03" title="Link target outside of Sample">About the Author</span></p>
<p class="toc"><span href="#/xhtml/bm04" title="Link target outside of Sample">Continue the Journey with Renée</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// toc.vue?c64391e2